import React from 'react';
import HashValueChange from './HashValueChange.jsx';
import ImpactReasonCard from './ImpactReasonCard.jsx';
import OrderedListChangesCard from './OrderedListChangesCard.jsx';
import UnorderedListChangeCard from './UnorderedListChangeCard.jsx';
import ValueChangesCard from './ValueChangesCard.jsx';
import AskReasonCard from './AskReason.jsx';

function humanizeKey(key) {
  return key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

export default function Impact({ impact }) {
  const impactSummary = Object.fromEntries(
    Object.entries(impact.ImpactSummary).filter(
      ([, value]) => value && value !== 0,
    ),
  );
  const summarizedImpactCount = Object.values(impactSummary).reduce(
    (a, b) => a + b,
    0,
  );
  $('#summarized-impact-count').text(summarizedImpactCount);

  const has_impact = summarizedImpactCount > 0;
  let has_review = false;
  let review_total;
  const impactForm = $('#impact-form');
  const confirmModal = $('#confirm-modal');
  const confirmInput = $('#confirm-input');
  const confirmBtn = $('#confirm');
  const confirmCheckbox = $('#confirm-checkbox > input');
  const impactDescription = $('#impact-changes-description');
  const pendingReviewCount = $('#impact-changes-review-count');
  const pendingReviewCheckbox = $('#impact-changes-review-missing');
  const pendingReviewTextContent = $('#pending-review');

  const SummaryBanner = () => {
    return (
      <>
        <div className='impact-summary-wrapper'>
          <div className='ui message red'>
            <div className='flex-container'>
              <div className='banner-icon'>
                <i className='icon huge exclamation triangle'></i>
              </div>
              <div className='banner-content'>
                <h3 className='ui header'>
                  <div className='content'>Impact Summary</div>
                </h3>
                <div className='impact-statistics'>
                  {Object.entries(impactSummary).map(([key, value]) => {
                    return (
                      <div
                        key={key}
                        className='impact-statistic'
                      >
                        <div className='value'>{value}</div>
                        <div className='label'>{humanizeKey(key)}</div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='ui content'>
          <h3 className='ui header'>Review your changes</h3>
          <p>
            The impact of your changes are summarized above and detailed below,
            providing an opportunity to visualize changes before they are saved.
            Please review it carefully before proceeding.
          </p>
        </div>
      </>
    );
  };

  const renderChangeComponent = (title) => {
    const { card_type } = impact[title];
    let ChangeComponent = null;

    switch (card_type) {
      case 'hash_value_change':
        ChangeComponent = HashValueChange;
        break;
      case 'impact_reason':
        ChangeComponent = ImpactReasonCard;
        break;
      case 'ordered_list_change':
        ChangeComponent = OrderedListChangesCard;
        break;
      case 'unordered_list_change':
        ChangeComponent = UnorderedListChangeCard;
        break;
      case 'value_change':
        ChangeComponent = ValueChangesCard;
        break;
      case 'ask_reason':
        ChangeComponent = AskReasonCard;
        break;
      default:
        ChangeComponent = null;
    }

    if (ChangeComponent !== null) {
      return React.createElement(ChangeComponent, {
        title,
        key: title,
        ...impact[title],
      });
    }

    return null;
  };

  const toggleImpactCountConfirmationVisibility = () => {
    if (!has_impact) {
      impactDescription.hide();
      pendingReviewCount.hide();
    }
  };

  const toggleMissingReviewCheckboxVisibility = () => {
    const total = $('#total');

    if (total && total.length) {
      const reviewed = $('#reviewed');
      review_total = parseInt(total.text()) - parseInt(reviewed.text());
      pendingReviewTextContent.text(review_total);

      if (review_total > 0) {
        if (pendingReviewCheckbox && pendingReviewTextContent) {
          pendingReviewCheckbox.show();
        }

        has_review = true;

        return;
      }
    }

    has_review = false;
    pendingReviewCheckbox.hide();
  };

  const confirmInputChanged = () => {
    confirmBtn.prop(
      'disabled',
      shouldDisableConfirmBtn(
        confirmInput.val(),
        has_review ? confirmCheckbox.is(':checked') : true,
      ),
    );
  };

  const shouldDisableConfirmBtn = (input, checkbox) => {
    const review_pending = $('#review_pending');
    review_pending.value = has_review ? review_total : false;

    if (isNaN(input)) {
      return true;
    }

    return !(
      (parseInt(input) == summarizedImpactCount || !has_impact) &&
      (checkbox || !has_review)
    );
  };

  const confirmBeforeSave = (event) => {
    toggleMissingReviewCheckboxVisibility();

    if (has_impact || has_review) {
      event.preventDefault();
      toggleImpactCountConfirmationVisibility();

      const form = impactForm[0];
      if (form && !form.reportValidity()) {
        return;
      }

      confirmModal
        .modal({
          onApprove: function () {
            impactForm.trigger('submit');
          },
        })
        .modal('show');
    }
  };

  confirmInput.on('keyup', confirmInputChanged);
  confirmCheckbox.on('click', confirmInputChanged);
  impactForm.find('button').on('click', confirmBeforeSave);

  return (
    <>
      {summarizedImpactCount > 0 ? <SummaryBanner /> : null}
      <div className='ui items'>
        {Object.keys(impact).map(renderChangeComponent)}
      </div>
    </>
  );
}
